import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { tokenInterceptor } from './Modules/Shared/Interceptors/token.interceptor';
import { loadingInterceptor } from './Modules/Shared/Interceptors/loading.interceptor';
import { httpLoaderFactory } from './Modules/Shared/Factories/translate-loader.factory';
import { TranslationService } from './Modules/Shared/Services/translation.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const lang = inject(TranslationService).resolveColdLoadLanguage();
      return firstValueFrom(inject(TranslateService).use(lang));
    }),

    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([tokenInterceptor, loadingInterceptor])),

    importProvidersFrom([
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ]),
  ],
};
